import React, { useEffect, useState } from 'react';
import { Form } from 'components/ds';
import { useNavigate } from 'react-router-dom';

// ============================================================================
// COMPONENTES LOCAIS
// ============================================================================
import PageContainer from 'modules/account/components/PageContainer/PageContainer';

// ============================================================================
// HOOKS E SERVIÇOS
// ============================================================================
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { usePostValidatePasswordOtp } from '../../../services/ValidationService';
import { useAuth } from 'auth/AuthProvider';

// ============================================================================
// UTILITÁRIOS
// ============================================================================
import { ApiLocalStorage } from 'utils/ApiLocalStorage';

// ============================================================================
// ESTILOS
// ============================================================================
import { ButtonLarge, DescriptionContainer, FooterDiv } from 'components/Css';
import {
  ResendButton,
  CircleInputContainer,
  Circle,
  HiddenInput,
  LoadingSpin,
} from '../styles';

// ============================================================================
// COMPONENTE
// ============================================================================

const PasswordValidationCode: React.FC = () => {
  const [form] = Form.useForm() as any;
  const [code, setCode] = useState('');
  const [seconds, setSeconds] = useState(42);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const navigate = useNavigate();
  const { login } = useAuth();

  const username = ApiLocalStorage.get('username');
  const { isLoading: isLoadingTemplate, data: pageConfig = {} } = useGetTemplate('passwordValidationCode');
  const { mutateAsync: validatePasswordOtp, isLoading: isLoadingValidatePassword } = usePostValidatePasswordOtp();

  const handleNext = async () => {
    try {
      const username = ApiLocalStorage.get('username');
      const result = await validatePasswordOtp(code);
      await login(username, JSON.stringify(result), '');
      navigate(pageConfig.navigateTo());
    } catch (error) {
      // Erro silencioso - tratamento pode ser adicionado aqui se necessário
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.slice(0, 6);
    setCode(value);
  };

  const handleResend = async () => {
    try {
      navigate(pageConfig.navigateBack());
      setSeconds(42);
      setIsResendDisabled(true);
    } catch (error) {
      // Erro silencioso - tratamento pode ser adicionado aqui se necessário
    }
  };

  useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    }
    
    setIsResendDisabled(false);
  }, [seconds]);

  const submitForm = () => {
    form.submit();
  };

  if (isLoadingTemplate || isLoadingValidatePassword) {
    return (
      <PageContainer>
        <LoadingSpin size="large" />
      </PageContainer>
    );
  }

  return (
    <PageContainer title={pageConfig.title} navigateBack={pageConfig?.navigateBack?.()}>
      <DescriptionContainer>Digite o código enviado</DescriptionContainer>
      <Form form={form} layout='vertical' onFinish={handleNext}>
        <CircleInputContainer>
          <HiddenInput
            type='number'
            value={code}
            onChange={handleInputChange}
            maxLength={6}
            autoFocus
            pattern='\d*'
          />
          {[...Array(6)].map((_, index) => (
            <Circle key={index}></Circle>
          ))}
        </CircleInputContainer>
      </Form>
      <FooterDiv>
        <ButtonLarge onClick={submitForm} disabled={code.length < 6}>
          {pageConfig.labelNext || 'Próximo'}
        </ButtonLarge>
        <ResendButton type='default' onClick={handleResend} disabled={isResendDisabled}>
          Reenviar em {seconds > 0 ? `${seconds} segundos` : 'agora'}
        </ResendButton>
      </FooterDiv>
    </PageContainer>
  );
};

export default PasswordValidationCode;
